
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/[merchantLocationId]",
      function () {
        return require("private-next-pages/m/[merchantLocationId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/[merchantLocationId]"])
      });
    }
  